// Tiny event bus that decouples the globally-mounted
// `<CommandPalette>` (in `DefaultLayout`) from the
// per-page sidebar "Search" button.
//
// The palette mounts once in the app-global layout and
// persists across navigations; the sidebar re-mounts per
// page. They can't share React state, so the button fires
// a window CustomEvent and the palette listens for it. A
// global ⌘/Ctrl-K keydown is wired inside the palette
// itself (it's app-global anyway) — this module only owns
// the explicit "open" request from the button.

const EVENT = "command-palette:open"

// Dispatch an open request. Safe to call from any page; the
// palette picks it up wherever it's mounted. No-op during
// SSR / jsdom-without-window.
export function openCommandPalette(): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(new CustomEvent(EVENT))
}

// Subscribe to open requests. Returns a cleanup function to
// remove the listener — wire it straight into a
// `useEffect` return.
export function onOpenCommandPalette(cb: () => void): () => void {
  if (typeof window === "undefined") return () => {}
  const handler = () => cb()
  window.addEventListener(EVENT, handler)
  return () => window.removeEventListener(EVENT, handler)
}
